import { useState } from "react";
import { useAuth, useLoad } from "../lib/api.jsx";
import { Wait, Tbl, Pager, Modal, F, csv, day, isExpired } from "../lib/ui.jsx";
import UserDetail from "./UserDetail.jsx";

export default function Users() {
  const { act } = useAuth();
  const [f, setF] = useState({ search: "", status: "", verified: "", page: 1 });
  const [d, reload] = useLoad("users", f);
  const [edit, setEdit] = useState(null);
  const [open, setOpen] = useState(null);
  const [note, setNote] = useState(null);
  const setFilter = (k, v) => setF({ ...f, [k]: v, page: 1 });

  const save = async () => {
    const r = await act(edit.SopnoID ? "user_update" : "user_add",
      { ...edit, sopnoid: edit.SopnoID, password: edit.password }, "Saved.");
    if (r) { setEdit(null); reload(); if (r.code || r.temp_password) setNote(r); }
  };
  const del = async (u) => {
    if (confirm(`Delete ${u.Name}? The profile is archived in the trash table and portal access is removed. Billing records stay.`)) {
      if (await act("user_delete", { sopnoid: u.SopnoID }, "User deleted.")) reload();
    }
  };

  return (
    <>
      <h1>Subscribers</h1>
      <div className="bar">
        <input placeholder="Search name, email, mobile, ID" value={f.search} onChange={(e) => setFilter("search", e.target.value)} />
        <select value={f.status} onChange={(e) => setFilter("status", e.target.value)}>
          <option value="">Any status</option><option value="1">Active</option><option value="0">Suspended</option>
        </select>
        <select value={f.verified} onChange={(e) => setFilter("verified", e.target.value)}>
          <option value="">Any verification</option><option value="1">Verified</option><option value="0">Unverified</option>
        </select>
        <button className="btn" onClick={() => setEdit({ Name: "", Email: "", MobileNumber: "", country: "Bangladesh", Location: "", Address: "", requ_for: "teamDesk", password: "" })}>Add user</button>
        <button className="btn g" onClick={() => d?.rows && csv("users", d.rows.map(({ Address, ...r }) => r))}>Export page</button>
      </div>
      <Wait d={d}>
        {d && !d.error && (
          <>
            <Tbl rows={d.rows} empty="No users match. Clear the filters or add a user." onRowClick={(u) => setOpen(u.SopnoID)} cols={[
              ["Name", (u) => u.Name],
              ["Email", (u) => u.Email],
              ["Mobile", (u) => u.MobileNumber],
              ["Verified", (u) => <span className={"tag " + (u.mail_veri == 1 ? "" : "wait")}>{u.mail_veri == 1 ? "verified" : "unverified"}</span>],
              ["Plan ends", (u) => (u.plan_end ? <span className={isExpired(u.plan_end) ? "tag wait" : ""}>{day(u.plan_end)}</span> : "-")],
              ["Account", (u) => (
                <select value={u.states} onChange={async (e) => { if (await act("user_status", { sopnoid: u.SopnoID, states: +e.target.value }, "Status updated.")) reload(); }}>
                  <option value={1}>Active</option><option value={0}>Suspended</option>
                </select>
              )],
              ["", (u) => (
                <>
                  <button className="btn g s" onClick={() => setOpen(u.SopnoID)}>Open</button>{" "}
                  <button className="btn g s" onClick={() => setEdit({ ...u, password: "" })}>Edit</button>{" "}
                  <button className="btn d s" onClick={() => del(u)}>Delete</button>
                </>
              )],
            ]} />
            <Pager f={f} setF={setF} d={d} />
          </>
        )}
      </Wait>

      {edit && (
        <Modal title={edit.SopnoID ? "Edit user" : "Add user"} onClose={() => setEdit(null)}>
          <div className="g2">
            <F label="Full name" v={edit.Name} set={(v) => setEdit({ ...edit, Name: v })} />
            <F label="Email" v={edit.Email} set={(v) => setEdit({ ...edit, Email: v })} />
            <F label="Mobile" v={edit.MobileNumber} set={(v) => setEdit({ ...edit, MobileNumber: v })} />
            <F label="Country" v={edit.country} set={(v) => setEdit({ ...edit, country: v })} />
            <F label="City / location" v={edit.Location} set={(v) => setEdit({ ...edit, Location: v })} />
            <F label="Signed up for" v={edit.requ_for} set={(v) => setEdit({ ...edit, requ_for: v })} />
          </div>
          <F label="Address" v={edit.Address} set={(v) => setEdit({ ...edit, Address: v })} />
          {!edit.SopnoID && <F label="Password (leave blank to generate one)" type="password" v={edit.password} set={(v) => setEdit({ ...edit, password: v })} />}
          <div className="bar"><button className="btn" onClick={save}>{edit.SopnoID ? "Save changes" : "Add user and create code"}</button></div>
        </Modal>
      )}
      {note && (
        <Modal title="Share with the user" onClose={() => setNote(null)}>
          {note.code && <p>Verification code: <b style={{ fontSize: 20, letterSpacing: 3 }}>{note.code}</b></p>}
          {note.temp_password && <p>Temporary password (shown once): <b>{note.temp_password}</b></p>}
        </Modal>
      )}
      {open && <UserDetail sopnoid={open} onClose={() => { setOpen(null); reload(); }} />}
    </>
  );
}
